import { render, staticRenderFns } from "./image-annotator.vue?vue&type=template&id=183dd4ba&scoped=true"
import script from "./image-annotator.vue?vue&type=script&lang=ts"
export * from "./image-annotator.vue?vue&type=script&lang=ts"
import style0 from "./image-annotator.vue?vue&type=style&index=0&id=183dd4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183dd4ba",
  null
  
)

export default component.exports